<template>
  <div class="goodAndBadTable">
    <div class="basInfo-table">
      <div class="row">
        <div class="col" v-if="isGood">良好信息事项</div>
        <div class="col" v-else>不良信息事项</div>
        <div class="col">
          {{
            deadlineObj.LevelContent && deadlineObj.LevelContentTwo
              ? deadlineObj.ItemName + '--' + deadlineObj.LevelContent + '-' + deadlineObj.LevelContentTwo
              : deadlineObj.LevelContent ? deadlineObj.ItemName + '--' + deadlineObj.LevelContent
              : deadlineObj.ItemName
          }}
        </div>
      </div>
      <div class="row">
        <div class="col" v-if="isGood">认定日期</div>
        <div class="col" v-else>信息录入日期</div>
        <div class="col">
          {{ dataInfoObj.StartEffectiveYear | formatDate('yyyy-MM-dd') }}
        </div>
        <div class="col">公示截止日期</div>
        <div class="col">
          <template>
            <span
              v-if="
                deadlineObj.NoticeEndTime == '9999-12-31T23:59:59' && isGood
              "
              >长期有效</span
            >
            <span v-else>{{
              deadlineObj.NoticeEndTime | formatDate('yyyy-MM-dd')
            }}</span>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col">计分</div>
        <div class="col">
          {{ isGood ? '+' + dataInfoObj.Score : dataInfoObj.Score }}
        </div>
        <div class="col">纳入计分年度</div>
        <div class="col">
          <span v-if="dataInfoObj.EffectiveYear"
            >{{ dataInfoObj.EffectiveYear }}年</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodAndBadTable',
  props: {
    isGood: Boolean,
    applyContent: String,
    dataInfoObj: {
      type: Object,
      default: {},
    },
    deadlineObj: Object,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.badAndgoodTable {
  .row {
    .col:nth-child(2n-1) {
      width: 400px;
    }
  }
}
</style>
